// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__fM5v0","info":"PatientInfo_info__kwRbQ"};